module.exports = __webpack_public_path__ + "static/media/AC08004D.494d729e.png";